module.exports = "/images/map-marker.svg?93c5a1b6c7737cc198dd88d53a6a02c5";